import { GridAction } from "@ctsu/ctsu-mui-grid";
import { OpenErrorNotification, OpenSuccessNotification } from "@ctsu/react-ctsu-ui";
import { DatePickerWithModal } from "components/common/Calender";
import { FormikSelect } from "components/common/FormFields/FormikSelect";
import { text } from "components/common/Text";
import { format } from "date-fns";
import { Field, Formik } from "formik";
import makeAjaxRequest from "helpers/makeAjaxRequest";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { rootUrl } from "stores/redux/actions/constants";
import { affilationLovSelector, fetchAffilationLov, fetchMCParticipants } from "stores/redux/slice/manageCommitte";
import PersonAutocomplete from "./PersonAutocomplete";

export function validateForm(values) {
  const errors = {};

  if (!values.personCtepId) {
    errors.personCtepId = "Person CTEP ID is required.";
  }

  if (!values.siteCtepId) {
    errors.siteCtepId = "Site CTEP ID is required.";
  }

  if (!values.esysStatus) {
    errors.esysStatus = "Status is required.";
  }

  return errors;
}

const esysStatusLov = [
  {
    label: "ACTIVE",
    value: "Active"
  },
  {
    label: "INACTIVE",
    value: "Inactive"
  }
];

export function submitManageCommittees(
  data,
  setIsSubmitting,
  onSucessCallback
) {
  setIsSubmitting(true);
  const obj = {
    group: data?.group,
    perId: data?.perId,
    ognId: data?.ognId,
    forObjType: data?.forObjType,
    forObjDbId: data?.forObjDbId,
    esysStatus: data?.esysStatus,
    roleId: data?.roleId,
    esysStatusDate: data?.esysStatusDate,
    id: data?.id || null
  };
  if (obj?.id == null) {
    delete obj.id;
  }
  makeAjaxRequest
    .putWithAuth(`${rootUrl}/admin/managecommittee/participant`, {
      ...obj
    })
    .then(() => {
      onSucessCallback();
      setIsSubmitting(false);
      OpenSuccessNotification({
        message: data?.rosterConfigId
          ? text("api.on_updating_record")
          : text("api.on_success_msg"),
        autoHide: true
      });
    })
    .catch((e) => {
      let message = e.message;
      if (e && e.message && e.message.includes("Duplicate record found")) {
        message = "Manage Committees Record already exists.";
      }
      OpenErrorNotification({
        message,
        autoHide: true
      });
    });
}

export function ParticipationRowForm({
  row,
  setEditing,
  objId,
  roleId,
  owner,
  objectType,
  siteLovData,
  isUpdating,
  statusOfMC
}) {
  const dispatch = useDispatch();
  const today = new Date();
  const formattedDate = format(today, "dd-MMM-yyyy");
  const onSucessCallback = () => dispatch(fetchMCParticipants({ forObjDbId: objId, roleId: roleId }));

  return (
    <Formik
      initialValues={{
        id: row?.id || "",
        group: row?.group || owner,
        perId: row?.perId || "",
        personCtepId: row?.personCtepId || "",
        personName: row?.personName || "",
        ognId: row?.ognId || "",
        siteCtepId: row?.siteCtepId || "",
        forObjType: row?.forObjType || objectType,
        forObjDbId: row?.forObjDbId || objId,
        esysStatus: row?.esysStatus || statusOfMC || "Active",
        roleId: roleId,
        esysStatusDate: row?.esysStatusDate || formattedDate
      }}
      onSubmit={(values, actions) => {
        setTimeout(() => {
          alert(JSON.stringify(values, null, 2));
          actions.setSubmitting(false);
        }, 1000);
      }}
    >
      {(props) => (
        <tr>
          <td>
            <label className="invisible" htmlFor="group">
              Owner
            </label>
            <div className="form-layout-wrapper bg-transparent position-relative">
              <div className="form-input-wrapper">
                <Field
                  {...{ props }}
                  name="group"
                  id="group"
                  edit={false}
                  disabled
                />
              </div>
            </div>
          </td>
          <td>
            <label className="invisible" htmlFor="personCtepId">
              Person CTEP ID
            </label>
            <div className="form-layout-wrapper bg-transparent position-relative">
              <div className="form-input-wrapper">
                {isUpdating
                  ? (
                    <Field
                      {...{ props }}
                      name="personCtepId"
                      id="personCtepId"
                      edit={false}
                      disabled
                    />
                  )
                  : (
                    <Field
                      {...{ props }}
                      name="personCtepId"
                      id="personCtepId"
                      component={PersonAutocomplete}
                      edit={true}
                      owner={owner}
                      onChange={(option) => {
                        props.setFieldValue("personName", option?.personName);
                        props.setFieldValue("perId", option?.perId);
                        props.setFieldValue("personCtepId", option?.ctepId);

                        if (option && option.perId) {
                          dispatch(fetchAffilationLov({ ...option, owner }));
                        }
                      }}
                    />
                  )}
              </div>
            </div>
          </td>
          <td>
            <label className="invisible" htmlFor="personName">
              Name
            </label>
            <div className="form-layout-wrapper bg-transparent position-relative">
              <div className="form-input-wrapper">
                {isUpdating
                  ? (
                    <Field
                      {...{ props }}
                      name="personName"
                      id="personName"
                      edit={false}
                      disabled
                    />
                  )
                  : (
                    <Field
                      {...{ props }}
                      name="personName"
                      id="personName"
                      component={PersonAutocomplete}
                      edit={true}
                      owner={owner}
                      onChange={(option) => {
                        props.setFieldValue("personName", option?.personName);
                        props.setFieldValue("perId", option?.perId);
                        props.setFieldValue("personCtepId", option?.ctepId);
                        if (option && option.perId) {
                          dispatch(fetchAffilationLov({ ...option, owner }));
                        }
                      }}
                    />
                  )}
              </div>
            </div>
          </td>
          <td>
            <label className="invisible" htmlFor="siteCtepId">
              Site CTEP ID
            </label>
            <div className="form-layout-wrapper bg-transparent position-relative">
              <div className="form-input-wrapper">
                {isUpdating
                  ? (
                    <Field
                      {...{ props }}
                      name="siteCtepId"
                      id="siteCtepId"
                      edit={false}
                      disabled
                    />
                  )
                  : (
                    <Field
                      {...{ props }}
                      name="siteCtepId"
                      id="siteCtepId"
                      component={FormikSelect}
                      edit={true}
                      options={siteLovData}
                      onChange={(eve) => {
                        props.setFieldValue("ognId", eve?.ognId);
                      }}
                    />
                  )}
              </div>
            </div>
          </td>
          <td>
            <label className="invisible" htmlFor="esysStatus">
              Status
            </label>
            <div className="form-layout-wrapper bg-transparent position-relative">
              <div className="form-input-wrapper">
                <Field
                  {...{ props }}
                  name="esysStatus"
                  id="esysStatus"
                  component={FormikSelect}
                  edit={true}
                  options={esysStatusLov}
                />
              </div>
            </div>
          </td>
          <td>
            <label className="invisible" htmlFor="esysStatusDate">
              Status Date
            </label>
            <div className="form-layout-wrapper bg-transparent position-relative">
              <div className="form-input-wrapper">
                {isUpdating
                  ? (
                    <Field
                      {...{ props }}
                      name="esysStatusDate"
                      id="esysStatusDate"
                      edit={false}
                      disabled
                    />
                  )
                  : (
                    <Field
                      {...{ props }}
                      name="esysStatusDate"
                      id="esysStatusDate"
                      as={DatePickerWithModal}
                      onChange={props.setFieldValue}
                    />
                  )}
              </div>
            </div>
          </td>

          <td>
            <GridAction
              save={() => {
                const errors = validateForm(props.values);
                if (errors && Object.keys(errors).length > 0) {
                  const errorMessage = Object.values(errors).join(" "); // Joining error messages
                  OpenErrorNotification({
                    message: errorMessage,
                    autoHide: true
                  });
                } else {
                  submitManageCommittees(
                    props.values,
                    setEditing,
                    onSucessCallback
                  );
                }
              }}
              cancel={() => setEditing(false)}
            />
          </td>
        </tr>
      )}
    </Formik>
  );
}

export default function EditRow({
  row,
  setEditing,
  objId,
  roleId,
  owner,
  objectType,
  statusOfMC
}) {
  const siteLovData = useSelector(affilationLovSelector);

  return (
    <ParticipationRowForm
      key={roleId}
      row={row}
      setEditing={setEditing}
      objId={objId}
      roleId={roleId}
      owner={owner}
      objectType={objectType}
      siteLovData={siteLovData}
      isUpdating={row && row.perId}
      statusOfMC={statusOfMC === "ACTIVE" ? "Active" : "Inactive"}
    />
  );
}
